module.exports = __webpack_public_path__ + "img/img-5.ea5be0f5.webp";